import React, { useState } from "react";

// assets
import { ICONS } from "assets/icons";
import Avatar from "assets/customSVG/Avatar";
import Map from "assets/customSVG/Map";

// helper
import { timeSince } from "helper/timeConversion";
import { abbrNum } from "helper/abbrNum";
import { replaceFormating } from "../../helper";

// components
import ConversationStar from "../conversation/ConversationStar";
import ConversationClose from "../conversation/ConversationClose";
import {
  FEATURE_FLAG_ADD_TO_STAR,
  FEATURE_FLAG_MANUALLY_CLOSE_CONVERSATION,
} from "../../constants/FeatureFlag";
import { Popover, Tooltip } from "antd";
import moment from "moment";
import { CONTACT_FILTERS, mediaIcons } from "../../constants";
import { cn } from "../../../../helper/cn";
import CheckBoxSqure from "../../../../components/commonComponents/checkbox/CheckBoxSqure";
import Favourite from "../../../../assets/customSVG/inbox/Favourite";
import Person from "../../../../assets/customSVG/Person";
import Resolved from "../../../../assets/customSVG/inbox/Resolved";
import Sent from "../../../../assets/customSVG/inbox/Sent";
import Delivered from "../../../../assets/customSVG/inbox/Delivered";
import RadioButton from "../../../../components/form/radio/RadioButton";

export default function CustomerPhoneNumberCard({
  item,
  selectedPerson,
  onSelectPerson,
  onFavoriteClick,
  onResolvedClick,
  onConversationStarChange,
  onCloseConversation,
  favorite,
  resolved,
}) {
  const {
    from_number,
    to_number,
    message,
    body,
    updated_at,
    last_send_at,
    unread_count,
    first_name,
    last_name,
    profile_name,
    resolve_status,
    is_customer_msg,
    status,
  } = item;

  // const newdate = moment(updated_at).format("YYYY-MM-DD");
  // const newdate = timeSince(updated_at, "single", false);

  // const newdate = new Date(last_send_at).toLocaleDateString("en-US", {
  //   month: "short",
  //   day: "numeric",
  //   year: "numeric",
  // });

  function formatRelativeTime(timestamp) {
    const currentTime = new Date();
    const pastTime = new Date(timestamp);
    const diffMs = currentTime - pastTime;
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

    if (diffMinutes < 60) {
      return `${diffMinutes} min`;
    }

    if (diffHours < 24) {
      return `${diffHours} hr`;
    }

    return pastTime.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  // Usage
  const lastSent = last_send_at; // Replace with your timestamp
  const newdate = formatRelativeTime(lastSent);

  const name =
    first_name && last_name
      ? `${first_name} ${last_name}`
      : first_name !== "UNKNOWN"
        ? first_name
        : last_name
          ? last_name
          : first_name === "UNKNOWN"
            ? profile_name
            : profile_name && profile_name;

  const dotStyle =
    'size-1.5 bg-[var(--BG-100)] contents-[""] rounded-full group-hove/dotsr:!bg-[var(--BG-100)]';

  const [hoveredDate, setHoveredDate] = useState(false);

  const handleMouseOver = () => {
    setHoveredDate(true);
  };

  const handleMouseOut = () => {
    setHoveredDate(false);
  };
  const messageTemplate = message?.template?.map((item) => item);

  // Extract only the BODY text
  const bodyText = messageTemplate
    ?.filter((item) => item.type === "BODY")
    ?.map((item) => item.text);

  const imageIcons = messageTemplate?.filter((item) => item.type === "HEADER");

  const renderInteractiveMessage = (message) => {
    const interactiveType = message?.interactive?.type;
  
    switch (interactiveType) {
      case 'cta_url':
      case 'flow':
      case 'location_request_message':
        return (
          <div className="flex flex-col gap-1 pt-2">
            <span
              className="w-full max-w-[16ch] pl-5 inbox-conversation text-ellipsis line-clamp-1"
              dangerouslySetInnerHTML={{
                __html:
                  replaceFormating(
                    message?.interactive?.header?.text
                      ? message?.interactive?.header?.text + message?.interactive?.body?.text
                      : message?.interactive?.body?.text,
                    true
                  ) ||
                  replaceFormating(message?.body, true) ||
                  bodyText,
              }}
            ></span>
          </div>
        );
  
      case 'button_reply':
        return (
          <div className="flex flex-col gap-1 pt-2">
            <span
              className="w-full max-w-[16ch] pl-5 inbox-conversation text-ellipsis line-clamp-1"
              dangerouslySetInnerHTML={{
                __html: replaceFormating(message?.interactive?.button_reply?.title, true)
              }}
            ></span>
          </div>
        );

      case 'nfm_reply':
        return (
          <div className="flex flex items-center pt-2">
              <img
                src={ICONS.documentInbox}
                alt={message?.type}
                className="media-icon size-[16px]"
              />
            <span
              className="w-full max-w-[16ch] pl-5 inbox-conversation text-ellipsis line-clamp-1"
            >Flow Response</span>
          </div>
        );
  
      default:
        return null;
    }
  };
  
  return (
    <div
      key={to_number}
      className={`w-full  border-[var(--border-50)] b-radius-6 flex-row align-center cursor-pointer transition-colors ease-linear duration-200  gap-x-[0.6vw] group   ${selectedPerson?.to_number === item?.to_number
        ? "bg-[#25C27729] border-l-2 !border-[#25C277]"
        : "bg-transparent border-b-[0.08vw] hover:bg-[#F4F6F8] hover:rounded-lg hover:border-b-[0]"
        }`}
      onMouseOver={() => handleMouseOver()}
      onMouseOut={handleMouseOut}
      onClick={() => {
        onSelectPerson(item);
      }}
    >
      <div
        className="flex items-center gap-x-[0.8vw]"
        style={
          {
            padding: "15px 15px 15px 8px",
          }
        }
      >
        <div className="relative top-0 left-0">
          <div className="size-[2.18vw] rounded-full flex items-center justify-center font-largest weight-medium">
            <Avatar color="#ffffff" />
          </div>
          <img
            src={ICONS?.whatsApp}
            alt="inbox"
            className="w-[1.2vw] h-[1.2vw] border-[0.2vw] border-[var(--white)] rounded-full z-20 absolute -bottom-[0vw] -right-[0.4vw]"
          />
        </div>
        <div className=" flex flex-col">
          <div
            className="flex items-center justify-between w-[12.8vw] group overflow-hidden"
          >
            {/* Name */}
            <div className="truncate capitalize sidebar-header max-w-[calc(100%-5rem)]">
              <Tooltip title={name}>
                <span>{name ?? to_number}</span>
              </Tooltip>
            </div>

            {/* Date / Favorite icon */}
            <div className="flex-shrink-0 text-right text-xs text-gray-500 ml-2">
              {!hoveredDate ? (
                <span className="whitespace-nowrap">{newdate}</span>
              ) : (
                <div
                  onClick={() => onFavoriteClick(item)}
                  className="cursor-pointer flex items-center justify-end"
                >
                  <Favourite
                    color={
                      favorite === item?.id || item?.is_favourite === true
                        ? "var(--a)"
                        : "var(--font-600)"
                    }
                    applyFill={
                      (favorite === item?.id || item?.is_favourite === true) ??
                      "var(--a)"
                    }
                  />
                </div>
              )}
            </div>
          </div>

          <div className="flex-row align-center space-between w-100">
            <div className="flex-row align-center">
              <div className="pt-5">
                {!hoveredDate &&
                  item?.message_status &&
                  item?.message_status !== "bounced" && (
                    <>
                      {item?.message_status === "sent" ? (
                        <Sent color={"var(--font-600)"} />
                      ) : (
                        <Delivered
                          color={
                            item?.message_status === "delivered"
                              ? "var(--font-600)"
                              : "#1778F2"
                          }
                        />
                      )}
                    </>
                  )}
              </div>
              <div className="flex-row align-center pt-5">
                {mediaIcons[imageIcons?.[0]?.format] && (
                  <img
                    src={mediaIcons[imageIcons?.[0]?.format]}
                    alt={message?.type}
                    className="media-icon"
                  />
                )}

                <span
                  className="w-full max-w-[16ch] pl-5 inbox-conversation text-ellipsis line-clamp-1"
                  dangerouslySetInnerHTML={{
                    __html:
                      replaceFormating(message?.text?.body, true) ||
                      replaceFormating(message?.body, true) ||
                      bodyText,
                  }}
                ></span>
              </div>

              {!["button", "interactive"].includes(message?.type) && (
                <span className="inbox-conversation flex-row align-center gap-1 pt-5">
                  {mediaIcons[message?.type] && (
                    <img
                      src={mediaIcons[message?.type]}
                      alt={message?.type}
                      className="media-icon"
                    />
                  )}
                  {(message?.image?.caption ||
                    message?.video?.caption ||
                    message?.document?.caption ||
                    message?.gif?.caption ||
                    message?.audio?.caption) && (
                      <span className="w-[full] truncate">
                        {["image", "video", "document", "audio", "gif"].includes(
                          message?.type
                        )
                          ? message?.type === "video"
                            ? message?.video?.caption
                            : message?.type === "image"
                              ? message?.image?.caption
                              : message?.type === "document"
                                ? message?.document?.caption
                                : message?.type === "audio"
                                  ? message?.audio?.caption
                                  : message?.gif?.caption
                          : null}
                      </span>
                    )}
                  {!(
                    message?.image?.caption ||
                    message?.video?.caption ||
                    message?.document?.caption ||
                    message?.gif?.caption ||
                    message?.audio?.caption ||
                    message?.location
                  ) && (
                      <span>
                        {["image", "video", "document", "audio", "gif", "location", "nfm_reply"].includes(
                          message?.type
                        ) &&
                          message.type.charAt(0).toUpperCase() +
                          message.type.slice(1)}
                      </span>
                    )}
                  {message?.type === 'location' && message?.location && (
                    <span className="inline-flex items-baseline gap-1">
                      <Map color="var(--font-600)" height="14px" width="14px" className="relative top-0.5" />
                      <span>Location</span>
                    </span>
                  )}
                </span>
              )}

              {message?.type === 'interactive' && ['cta_url', 'flow', 'location_request_message', 'button_reply', 'list_reply', 'nfm_reply'].includes(message?.interactive?.type) && (
                renderInteractiveMessage(message)
              )}

              {message?.type === 'contacts' && (
                <div className="inbox-conversation flex-row align-center gap-1 pt-5">
                  <span className="flex items-center gap-1">
                    <Person fill="var(--font-600)" height="16px" width="16px" className="relative top-0.5" />
                    <span>{message?.contacts?.[0]?.name?.formatted_name}</span>
                  </span>
                </div>
              )}

              {["button"].includes(message?.type) && (
                <span className="Capitalize inbox-conversation">
                  {["button"].includes(message?.type) && message.button?.text}
                </span>
              )}
            </div>
            {hoveredDate && (
              <div
                onClick={() => {
                  onResolvedClick(item);
                }}
              >
                <>
                  {item?.resolve_status === false ? (
                    <div className="mr-[6px] mt-5">
                      <RadioButton
                        selected={true}
                      // disabled={item?.resolve_status === false}
                      />
                    </div>
                  ) : (
                    <Resolved
                      color={"var(--font-600)"}
                      lineColor={"var(--font-600)"}
                    />
                  )}
                </>
              </div>
            )}
            {!hoveredDate && item?.unread_count > 0 && (
              <span className="py-0.45 px-2 flex items-center justify-center rounded-full bg-[#FF543E] border-[var(--white)] text-[white] text-[0.65rem] font-[600]">
                {item?.unread_count > 99 ? "99+" : item?.unread_count}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
